import React from "react";
import NavBarList from "../../variables/NavBarList";
import Typography from "../../Typography";

export default function Footer() {
  return (
    <div className="bg-white">
      <a href="https://" className="hover:opacity-80 opacity-100 duration-300">
        <img
          alt="map"
          className="w-full max-xsm:h-[200px] max-sm:h-[250px] max-md:h-[300px] h-[400px] object-cover"
          src="./imgs/map/map.webp"
        />
      </a>
      <div className="max-sm:max-w-[320px] max-md:py-[20px] flex flex-wrap wrapper py-[30px] items-center justify-center gap-[25px] gap-y-[15px]">
        {NavBarList.filter((NavLink) => NavLink.type !== "tel").map(
          (NavLink, index) => (
            <div key={index}>
              <a
                className="hover:opacity-80 opacity-100 duration-300"
                href={NavLink.url}
              >
                <p className="text-black max-md:text-[16px] text-[22px] font-[600] font-primary leading-[130%]">
                  {NavLink.label}
                </p>
              </a>
            </div>
          )
        )}
      </div>
      <div className="bg-black py-[30px]">
        <div className="wrapper">
          <Typography.P className="text-white text-center">
            © 2025 All Rights Reserved
          </Typography.P>
        </div>
      </div>
    </div>
  );
}
